<template>
<div>
<ProjectCard  :project_id="$route.params.id" :show_project_link="false"/>
</div>
</template>

<script>
export default {

  name: 'ProjectStatus',

  data () {
    return {

    }
  },
  mounted()
  {
    this.$store.dispatch('ui/setActiveTab',"durum")
  }
}
</script>

<style lang="css" scoped>
</style>